/**
 * Deep merge two objects.
 */
export function deepMerge<T extends object>(
  target: T | null,
  source: T | null | undefined,
): T | null {
  if (source === null) {
    return null as unknown as T;
  }

  if (!source) {
    return target;
  }

  if (!target) {
    target = (Array.isArray(source) ? [] : {}) as T;
  }

  if (Array.isArray(target)) {
    if (Array.isArray(source)) {
      target.push(...source);
    } else {
      target.push(source);
    }

    return target;
  }

  for (const key in source) {
    if (!Object.prototype.hasOwnProperty.call(source, key)) {
      continue;
    }

    if (source[key] === undefined) {
      continue;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    target[key] =
      typeof source[key] === 'object'
        ? deepMerge(target[key] as object, source[key] as object)
        : // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (source[key] as any);
  }

  return target;
}
